export const DEV_ROUTE = {
    path: 'component',
    loadComponent: () =>
        import('./dummy-component/dummy-component.component').then(m => m.DummyComponentComponent),
};
